import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { useOrder, usePractice } from '@witmetrics/data-store';
import { formatOrderName } from '@witmetrics/utils/orders';
import { classes, styles } from './utils';

export type ResultsListItemProps = {
  orderId: number;
  onSelect: (orderId: number) => void;
};

export default function ResultsListItem({
  orderId,
  onSelect,
}: ResultsListItemProps) {
  const order = useOrder(orderId);
  const practice = usePractice(order?.practiceId);

  if (!order || !practice) return null;

  return (
    <ListItem disablePadding>
      <ListItemButton
        sx={styles.listItemButton}
        className={classes.listItemButton}
        onClick={() => onSelect(orderId)}>
        <ListItemText
          primary={`${formatOrderName(order)} | ${practice.name}`}
          secondary={order.externalRef}
        />
      </ListItemButton>
    </ListItem>
  );
}
